module.exports = __webpack_public_path__ + "img/stories-mobile-english.7e65fae5.png";